import styled from 'styled-components';
import GenericErrorIcon from 'assets/images/generic-error.react.svg';
import { HelpCenterContainer } from 'view/help-center/container';
import * as bp from 'view/styles/breakpoints';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { TopicsList as StyledList } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const TopicsList = styled(StyledList)<{ count: number }>`
    ${bp.fromMedium.css`
    & > li {
        flex-basis: ${({ count }) => {
            if (count > 2) {
                return '33%';
            }
            if (count === 2) {
                return '50%';
            }
            return '100%';
        }};
    };`}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ListItem = styled.li`
    margin-top: 0;
    padding: ${token('space.200', '16px')};
    box-sizing: border-box;
    overflow: hidden;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const GreyWarningIcon = styled(GenericErrorIcon)`
    /* height of icon is not multiple of grid to prevent icon from being warped */
    height: ${grid.multiple(14.375).px};
    width: ${grid.multiple(11).px};
    margin-bottom: ${token('space.200', '16px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Message = styled.div`
    ${fonts.h600};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ContactDescription = styled.p`
    ${fonts.regular};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledHelpCenterContainer = styled(HelpCenterContainer)`
    margin-bottom: ${token('space.600', '48px')};
`;
